import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { RegistrationFlowService } from '../registration-flow/registration-flow.service';

@Injectable({ providedIn: 'root' })
export class RegistrationFlowStepsResolverService implements Resolve<string[] | null> {
  constructor(private registrationFlowService: RegistrationFlowService) {}

  resolve(): Observable<string[] | null> {
    return this.registrationFlowService.loadSteps();
  }
}
